import { Action } from '@ngrx/store';
import { TMMFactoryActionTypes } from './factory.models';

export class SetFactoryId implements Action {
  readonly type = TMMFactoryActionTypes.SetFactoryId;
  constructor(public factoryId: string) {}
}

export class SetUserName implements Action {
  readonly type = TMMFactoryActionTypes.SetUserName;
  constructor(public userName: string) {}
}

export type TFactoryActions = SetFactoryId | SetUserName;
